import React from "react";
import { Tip } from "../../components/ui/tooltip";

/* ── Stat Card ── */
const statColors: Record<
  string,
  { icon: string; iconBg: string; bg: string; ring: string; border: string }
> = {
  indigo: {
    icon: "text-indigo-500 dark:text-indigo-400",
    iconBg: "bg-indigo-100/80 dark:bg-indigo-500/15",
    bg: "bg-indigo-50/40 dark:bg-indigo-500/[0.06]",
    ring: "ring-indigo-200/60 dark:ring-indigo-500/20",
    border: "border-l-indigo-400 dark:border-l-indigo-500",
  },
  sky: {
    icon: "text-sky-500 dark:text-sky-400",
    iconBg: "bg-sky-100/80 dark:bg-sky-500/15",
    bg: "bg-sky-50/40 dark:bg-sky-500/[0.06]",
    ring: "ring-sky-200/60 dark:ring-sky-500/20",
    border: "border-l-sky-400 dark:border-l-sky-500",
  },
  amber: {
    icon: "text-amber-500 dark:text-amber-400",
    iconBg: "bg-amber-100/80 dark:bg-amber-500/15",
    bg: "bg-amber-50/40 dark:bg-amber-500/[0.06]",
    ring: "ring-amber-200/60 dark:ring-amber-500/20",
    border: "border-l-amber-400 dark:border-l-amber-500",
  },
  emerald: {
    icon: "text-emerald-500 dark:text-emerald-400",
    iconBg: "bg-emerald-100/80 dark:bg-emerald-500/15",
    bg: "bg-emerald-50/40 dark:bg-emerald-500/[0.06]",
    ring: "ring-emerald-200/60 dark:ring-emerald-500/20",
    border: "border-l-emerald-400 dark:border-l-emerald-500",
  },
  slate: {
    icon: "text-slate-400 dark:text-white/40",
    iconBg: "bg-slate-100/80 dark:bg-white/[0.06]",
    bg: "bg-slate-50/60 dark:bg-white/[0.03]",
    ring: "ring-slate-200/50 dark:ring-white/[0.08]",
    border: "border-l-slate-300 dark:border-l-white/20",
  },
};

export function StatCard({
  icon,
  label,
  value,
  color = "slate",
  dim = false,
  tooltip,
  valueClassName = "",
}: {
  icon: React.ReactNode;
  label: string;
  value: string;
  color?: string;
  dim?: boolean;
  tooltip?: string;
  valueClassName?: string;
}) {
  const c = statColors[color] ?? statColors.slate;
  const valueEl = (
    <span
      className={`block leading-tight truncate ${dim ? "text-xs italic text-muted-foreground/70" : "text-sm font-semibold text-foreground"} ${valueClassName}`}
    >
      {value}
    </span>
  );
  return (
    <div
      className={`flex items-center gap-3 px-4 py-3 rounded-xl ${c.bg} ring-1 ${c.ring} border-l-2 ${c.border} transition-colors`}
    >
      <div
        className={`flex-shrink-0 size-8 rounded-lg ${c.iconBg} flex items-center justify-center`}
      >
        <span className={c.icon}>{icon}</span>
      </div>
      <div className="flex flex-col gap-0.5 min-w-0">
        <span className="text-[12px] font-bold tracking-widest text-muted-foreground">
          {label}
        </span>
        {tooltip ? (
          <Tip
            label={tooltip}
            className="min-w-0"
            contentClassName="max-w-xs break-words"
          >
            {valueEl}
          </Tip>
        ) : (
          valueEl
        )}
      </div>
    </div>
  );
}
